export function passwordGenerator() {
  const specialChars = '!@$!%*?&';
  const numbers = '0123456789';
  const lowerChars = 'abcdefghijklmnopqrstuvwxyz';
  const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let password = '';

  // Generate a random index for the special character
  const specialIndex = Math.floor(Math.random() * specialChars.length);

  // Generate a random index for the number
  const numberIndex = Math.floor(Math.random() * numbers.length);

  // Add the special character and number to the password
  password += specialChars[specialIndex] + numbers[numberIndex];

  // Generate random remaining characters for the password
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * (lowerChars + upperChars).length);
    password += (lowerChars + upperChars)[randomIndex];
  }

  // Shuffle the password
  password = password
    .split('')
    .sort(function () {
      return 0.5 - Math.random();
    })
    .join('');
  return password;
}
